// src/app/actions/checklists.js
// Operational Checklist template CRUD (Phase 1). Mirrors actions/templates.js.

// --- Action Types ---
export const FETCH_CHECKLISTS_REQUEST = 'FETCH_CHECKLISTS_REQUEST'
export const FETCH_CHECKLISTS_SUCCESS = 'FETCH_CHECKLISTS_SUCCESS'
export const FETCH_CHECKLISTS_FAILURE = 'FETCH_CHECKLISTS_FAILURE'

export const CREATE_CHECKLIST_REQUEST = 'CREATE_CHECKLIST_REQUEST'
export const CREATE_CHECKLIST_SUCCESS = 'CREATE_CHECKLIST_SUCCESS'
export const CREATE_CHECKLIST_FAILURE = 'CREATE_CHECKLIST_FAILURE'

export const UPDATE_CHECKLIST_REQUEST = 'UPDATE_CHECKLIST_REQUEST'
export const UPDATE_CHECKLIST_SUCCESS = 'UPDATE_CHECKLIST_SUCCESS'
export const UPDATE_CHECKLIST_FAILURE = 'UPDATE_CHECKLIST_FAILURE'

export const DELETE_CHECKLIST_REQUEST = 'DELETE_CHECKLIST_REQUEST'
export const DELETE_CHECKLIST_SUCCESS = 'DELETE_CHECKLIST_SUCCESS'
export const DELETE_CHECKLIST_FAILURE = 'DELETE_CHECKLIST_FAILURE'

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token')}`
})

// GET /checklists
export const fetchChecklists = tenant => {
  return async dispatch => {
    dispatch({ type: FETCH_CHECKLISTS_REQUEST })
    try {
      const res = await fetch(tenant.getApiUrl('checklists'), {
        method: 'GET',
        headers: authHeaders()
      })
      if (!res.ok) throw new Error('Failed to retrieve checklists')
      const data = await res.json()
      dispatch({
        type: FETCH_CHECKLISTS_SUCCESS,
        payload: (data.res && data.res.data) || []
      })
    } catch (err) {
      dispatch({ type: FETCH_CHECKLISTS_FAILURE, payload: err.message })
    }
  }
}

// POST /checklists
export const createChecklist = (tenant, body) => {
  return async dispatch => {
    dispatch({ type: CREATE_CHECKLIST_REQUEST })
    try {
      const res = await fetch(tenant.getApiUrl('checklists'), {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(body)
      })
      const data = await res.json()
      if (!res.ok || !(data.res && data.res.success)) {
        throw new Error((data.res && data.res.message) || 'Failed to create checklist')
      }
      dispatch({ type: CREATE_CHECKLIST_SUCCESS, payload: data.res.data })
      return data.res.data
    } catch (err) {
      dispatch({ type: CREATE_CHECKLIST_FAILURE, payload: err.message })
      throw err
    }
  }
}

// PUT /checklists/:id
export const updateChecklist = (tenant, id, body) => {
  return async dispatch => {
    dispatch({ type: UPDATE_CHECKLIST_REQUEST })
    try {
      const res = await fetch(`${tenant.getApiUrl('checklists')}/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify(body)
      })
      const data = await res.json()
      if (!res.ok || !(data.res && data.res.success)) {
        throw new Error((data.res && data.res.message) || 'Failed to update checklist')
      }
      dispatch({ type: UPDATE_CHECKLIST_SUCCESS, payload: data.res.data })
      return data.res.data
    } catch (err) {
      dispatch({ type: UPDATE_CHECKLIST_FAILURE, payload: err.message })
      throw err
    }
  }
}

// DELETE /checklists/:id (soft delete)
export const deleteChecklist = (tenant, id) => {
  return async dispatch => {
    dispatch({ type: DELETE_CHECKLIST_REQUEST })
    try {
      const res = await fetch(`${tenant.getApiUrl('checklists')}/${id}`, {
        method: 'DELETE',
        headers: authHeaders()
      })
      const data = await res.json()
      if (!res.ok || !(data.res && data.res.success)) {
        throw new Error((data.res && data.res.message) || 'Failed to delete checklist')
      }
      dispatch({ type: DELETE_CHECKLIST_SUCCESS, payload: id })
      return id
    } catch (err) {
      dispatch({ type: DELETE_CHECKLIST_FAILURE, payload: err.message })
      throw err
    }
  }
}